"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionalFeeExchange = exports.default = void 0;

var _types = require("@plugnet/types");

// Copyright 2019 Centrality Investments Limited
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
class FeeExchange extends _types.Struct {
  constructor(value) {
    const typeRegistry = (0, _types.getTypeRegistry)();
    const AssetId = typeRegistry.getOrThrow('AssetId');
    const Balance = typeRegistry.getOrThrow('Balance');
    super({
      assetId: _types.Compact.with(AssetId),
      maxPayment: _types.Compact.with(Balance)
    }, value);
  }

}

exports.default = FeeExchange;

class OptionalFeeExchange extends _types.Option.with(FeeExchange) {}

exports.OptionalFeeExchange = OptionalFeeExchange;